<template>
  <div class="page-container douyin-hp-page" v-loading="isLoading">
    <div class="search-box">
      <div class="search-main flex-row">
        <el-input
          v-model="keyword"
          clearable
          placeholder="请输入商品名称"
          @keyup.enter.native="search"
          @clear="search" />
        <el-button class="search-btn" @click="search">搜索</el-button>
      </div>
    </div>

    <div class="filters" v-if="!keyword.trim()">
      <div class="filter-row">
        <span class="filter-label">榜单</span>
        <span
          v-for="item in rankTimes"
          :key="item.value"
          :class="['filter-item', { active: time === item.value }]"
          @click="changeTime(item.value)">
          {{ item.label }}
        </span>
      </div>
      <div class="filter-row">
        <span class="filter-label">分类</span>
        <span
          v-for="item in categories"
          :key="item.value"
          :class="['filter-item', { active: category === item.value }]"
          @click="changeCategory(item.value)">
          {{ item.label }}
        </span>
      </div>
    </div>

    <div v-if="list.length" class="cards-container">
      <div v-for="item in list" :key="item.productId" class="product-card">
        <el-image
          v-if="item.productImage"
          class="product-image"
          fit="cover"
          :src="item.productImage"
          :preview-src-list="[item.productImage]" />
        <img v-else class="product-image" src="@/assets/images/default.png" />
        <div class="product-content">
          <div class="product-name" :title="item.productName">{{ item.productName }}</div>
          <div v-if="item.authorName || item.shopName" class="source-name" :title="item.authorName || item.shopName">
            {{ item.authorName || item.shopName }}
          </div>
          <div class="price-row">
            <span class="price">¥{{ formatAmount(item.price) }}</span>
            <span class="original-price">¥{{ formatAmount(item.originalPrice) }}</span>
            <span v-if="item.userRebate !== null && item.userRebate !== undefined" class="discount">折扣{{ item.userRebate }}折</span>
          </div>
          <div class="commission-row">
            <span>预计佣金</span>
            <strong>¥{{ formatAmount(item.commission) }}</strong>
            <span v-if="item.commissionRate !== null && item.commissionRate !== undefined">{{ formatAmount(item.commissionRate) }}%</span>
          </div>
          <div class="actions">
            <el-button size="small" @click="showCommand(item)">获取口令</el-button>
            <el-button size="small" type="primary" @click="getProductUrl(item)">获取链接</el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="!isLoading" class="no-data">暂无数据</div>

    <div class="page-pagination" v-if="pageInfo.total">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        :page-sizes="pageInfo.sizes"
        :current-page="pageInfo.pageIndex"
        @current-change="changePage"
        @size-change="changePageSize" />
    </div>

    <BaseDailog
      v-if="showCommandDialog"
      v-model="showCommandDialog"
      width="480px"
      :showCancel="false"
      title="抖音APP口令"
      confirmText="复制口令"
      @confirm="copyCommand">
      <div class="command-dialog" v-loading="commandLoading">
        <div class="command-product">{{ currentProduct && currentProduct.productName }}</div>
        <div class="command-value">{{ command || '口令生成失败，请稍后重试' }}</div>
        <div class="command-tip">口令有效期：1小时</div>
      </div>
    </BaseDailog>

  </div>
</template>

<script>
import BaseDailog from '@/page/component/sections/base-dailog'
import { copyFn } from '@/utils/util'
import { getDouyinHpPromotionCommand, queryDouyinHpProductQdH5Page } from '@/service/apis/kl'

const rankTimes = [
  { label: '近24小时', value: 24 },
  { label: '近7天', value: 7 }
]

const categories = [
  { label: '综合', value: 0 },
  { label: '食品饮料', value: 1 },
  { label: '服饰配饰', value: 2 },
  { label: '美妆日化', value: 3 },
  { label: '家居建材', value: 4 },
  { label: '宠物用品', value: 5 }
]

export default {
  name: 'XpkDouyinHp',
  components: {
    BaseDailog
  },
  data () {
    return {
      rankTimes,
      categories,
      keyword: '',
      time: 24,
      category: 0,
      isLoading: false,
      list: [],
      pageInfo: {
        pageIndex: 1,
        pageSize: 20,
        sizes: [10, 20, 30, 50, 100],
        total: 0
      },
      currentProduct: null,
      command: '',
      commandLoading: false,
      showCommandDialog: false
    }
  },
  created () {
    this.getList()
  },
  methods: {
    formatAmount (value) {
      return value === null || value === undefined || value === '' ? '--' : value
    },
    search () {
      this.pageInfo.pageIndex = 1
      this.getList()
    },
    changeTime (time) {
      this.time = time
      this.search()
    },
    changeCategory (category) {
      this.category = category
      this.search()
    },
    changePage (pageIndex) {
      this.pageInfo.pageIndex = pageIndex
      this.getList()
    },
    changePageSize (pageSize) {
      this.pageInfo.pageSize = pageSize
      this.pageInfo.pageIndex = 1
      this.getList()
    },
    getList () {
      this.isLoading = true
      queryDouyinHpProductQdH5Page.call(this, {
        pageIndex: this.pageInfo.pageIndex,
        pageSize: this.pageInfo.pageSize,
        keyword: this.keyword.trim(),
        time: this.time,
        category: this.category
      }).then(res => {
        this.list = (res && res.records) || []
        this.pageInfo.total = Number((res && res.total) || 0)
      }).finally(() => {
        this.isLoading = false
      })
    },
    showCommand (product) {
      this.currentProduct = product
      this.command = ''
      this.showCommandDialog = true
      this.commandLoading = true
      getDouyinHpPromotionCommand.call(this, {
        id: product.conversionLinkId,
        accountId: product.accountId,
        shopType: 'douyinHP',
        type: 'goods'
      }).then(res => {
        this.command = (res && res.command) || ''
      }).finally(() => {
        this.commandLoading = false
      })
    },
    copyCommand () {
      if (!this.command) {
        this.$message.warning('暂无可复制口令')
        return
      }
      copyFn(this.command, () => {
        this.$message.success('口令已复制')
        this.showCommandDialog = false
      })
    },
    getProductUrl (product) {
      if (!product || !product.url) {
        this.$message.warning('暂无商品链接，请稍后重试')
        return
      }
      copyFn(product.url, () => {
        this.$message.success('商品链接已复制')
      })
    }
  }
}
</script>

<style scoped>
.search-box {
  padding: 24px 0 12px;
  background: #fff;
}

.search-main {
  width: 720px;
  margin: 0 auto;
  border: 1px solid #f74eb5;
  border-radius: 4px;
  overflow: hidden;
}

.search-main ::v-deep .el-input__inner {
  border: 0;
}

.search-btn {
  border: 0;
  border-radius: 0;
  color: #fff;
  background: linear-gradient(270deg, #ff38b9 0%, #ff6f85 100%);
}

.filters {
  padding: 12px 24px;
  background: #fff;
  border-top: 1px solid #f5f5f5;
}

.filter-row {
  display: flex;
  align-items: center;
  min-height: 32px;
}

.filter-label {
  width: 48px;
  color: #666;
  font-size: 13px;
}

.filter-item {
  margin-right: 24px;
  color: #333;
  cursor: pointer;
  font-size: 13px;
}

.filter-item.active,
.filter-item:hover {
  color: #f74eb5;
  font-weight: 600;
}

.cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
  padding: 16px 24px;
}

.product-card {
  overflow: hidden;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.product-image {
  display: block;
  width: 100%;
  height: 220px;
  object-fit: cover;
}

.product-content {
  padding: 12px;
}

.product-name {
  display: -webkit-box;
  height: 40px;
  overflow: hidden;
  color: #222;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.source-name {
  overflow: hidden;
  margin-top: 4px;
  color: #999;
  font-size: 12px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.price-row,
.commission-row,
.actions {
  display: flex;
  align-items: center;
}

.price-row {
  min-height: 32px;
  margin-top: 8px;
}

.price {
  margin-right: 8px;
  color: #f74eb5;
  font-size: 20px;
  font-weight: 700;
}

.original-price {
  color: #999;
  font-size: 12px;
  text-decoration: line-through;
}

.discount {
  margin-left: auto;
  padding: 2px 6px;
  border-radius: 2px;
  color: #f74eb5;
  background: #fff0f9;
  font-size: 12px;
}

.commission-row {
  gap: 6px;
  color: #666;
  font-size: 12px;
}

.commission-row strong {
  color: #ff6f00;
  font-size: 16px;
}

.actions {
  margin-top: 12px;
}

.actions .el-button {
  flex: 1;
}

.actions .el-button + .el-button {
  margin-left: 8px;
}

.page-pagination {
  padding: 8px 24px 24px;
  text-align: right;
}

.no-data {
  padding: 100px 0;
  color: #999;
  text-align: center;
}

.command-product {
  margin-bottom: 12px;
  color: #222;
  font-weight: 600;
}

.command-value {
  min-height: 64px;
  padding: 12px;
  border-radius: 4px;
  color: #333;
  background: #f7f7f7;
  line-height: 22px;
  word-break: break-all;
}

.command-tip {
  margin-top: 10px;
  color: #999;
  font-size: 12px;
}
</style>
